// extracted by mini-css-extract-plugin
export default {"body":"styles_body__Xc7Xx","modal":"styles_modal__DutiV","modal_close_button":"styles_modal_close_button__KVtTy","overlay":"styles_overlay__LVjwn","appear":"styles_appear__K6MTz"};